import React from "react";
import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";

export type SectionShellProps = Readonly<{
  id?: string;
  title: string;
  eyebrow?: string;
  description?: string;
  children: React.ReactNode;
}>;

export default function SectionShell({ id, title, eyebrow, description, children }: SectionShellProps) {
  const theme = useTheme();

  return (
    <Stack
      id={id}
      spacing={3}
      component="section"
      sx={{
        py: { xs: 4, md: 6 },
      }}
    >
      <Stack spacing={1.5} sx={{ maxWidth: 720 }}>
        {!eyebrow ? null : (
          <Typography variant="body2" sx={{ color: alpha(theme.palette.primary.contrastText, 0.7) }}>
            {eyebrow}
          </Typography>
        )}
        <Typography variant="h3" color="primary.contrastText">
          {title}
        </Typography>
        <Box sx={{ width: { xs: 56, md: 72 }, height: 3, bgcolor: alpha(theme.palette.info.main, 0.42) }} />
        {!description ? null : (
          <Typography variant="body1" sx={{ color: alpha(theme.palette.primary.contrastText, 0.78) }}>
            {description}
          </Typography>
        )}
      </Stack>
      {children}
    </Stack>
  );
}
